import { render, staticRenderFns } from "./guest-page.vue?vue&type=template&id=203812a8&"
import script from "./guest-page.vue?vue&type=script&lang=js&"
export * from "./guest-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203812a8')) {
      api.createRecord('203812a8', component.options)
    } else {
      api.reload('203812a8', component.options)
    }
    module.hot.accept("./guest-page.vue?vue&type=template&id=203812a8&", function () {
      api.rerender('203812a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/guest-page.vue"
export default component.exports